import { useCallback } from 'react';
import { ProviderSignUpForm, ProviderSignUpFormValue } from './ProviderSignUpForm';
import { useSignUpProviderMutation } from '@app/main/api';
import { withEmployeeProviderDefaults } from '@app/main/widgets/Employees.Details';

interface Props {
  onSubmitted: () => any;
}

const useSubmit = (props: Props) => {
  const { onSubmitted } = props;
  const [signUp] = useSignUpProviderMutation();

  return useCallback(
    async (values: ProviderSignUpFormValue) =>
      signUp(withEmployeeProviderDefaults(values)).unwrap().then(onSubmitted),
    [onSubmitted, signUp],
  );
};

export function ProviderSignUpPanel(props: Props) {
  const onSubmit = useSubmit(props);
  return <ProviderSignUpForm onSubmit={onSubmit} />;
}
